import React from 'react';

const CourseCard = ({ title, description, duration, features, imageUrl }) => {
  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-100 transition-shadow duration-300 hover:shadow-xl group">
      {/* Image with subtle overlay on hover */}
      <div className="relative overflow-hidden">
        <img 
          src={imageUrl} 
          alt={title} 
          className="w-full h-40 object-cover group-hover:scale-105 transition-transform duration-500" 
        />
        {/* Duration badge */}
        <div className="absolute top-0 right-0 bg-purple-700 text-white text-xs font-bold px-3 py-1 rounded-bl-lg">
          {duration}
        </div>
      </div>
      
      <div className="p-5">
        <h3 className="text-xl font-bold text-gray-800 group-hover:text-pink-600 transition-colors duration-300 mb-2">{title}</h3>
        
        {/* Short Description */}
        <p className="text-gray-500 text-sm mb-4 line-clamp-2">{description}</p>
        
        {/* Key Features List (More compact) */}
        <ul className="text-left space-y-2 mb-5">
          {features.slice(0, 3).map((feature, index) => ( // Display top 3 features
            <li key={index} className="flex items-center text-gray-700 text-sm">
              <svg className="w-4 h-4 text-pink-500 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              <span>{feature}</span>
            </li>
          ))}
          {features.length > 3 && (
             <li className="text-pink-500 text-sm italic mt-1">... and more</li>
          )}
        </ul>
        
        {/* Enrollment Button */}
        <button className="w-full bg-purple-800 text-white font-semibold py-2 rounded-lg hover:bg-pink-600 transition duration-300 text-sm uppercase tracking-wider">
          View Details & Enroll
        </button>
      </div>
    </div>
  );
};

export default CourseCard;